import React, { FC } from 'react'
import styled from 'styled-components'

import SadFaceIcon from '@Assets/SVG/SadFace'
import WarningIcon from '@Assets/SVG/Warning'
import { SVGIcon } from '@Components/Icons'
import { ContentProps } from '@Components/Modal/Dialog'
import { box, flexCenterChildrenColumn } from '@Globals/Style/mixins'

const Wrapper = styled.div`
  ${flexCenterChildrenColumn};
  padding-top: 30px;
  .iconWrapper {
    ${box({ width: '60px' })}
    margin-bottom: 20px;
  }
  .title {
    display: block;
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 10px;
    max-width: 100%;
  }
  .text {
    display: block;
    text-align: center;
    color: ${({ theme }) => theme.colors.grey};
    max-width: 100%;
  }
`

export const ErrorContent: FC<ContentProps> = ({
  children,
  title,
  variant,
}) => (
  <Wrapper>
    <div className="iconWrapper">
      <SVGIcon color={variant === 'sadError' ? 'greyDark' : 'primary'} icon={variant === 'sadError' ? SadFaceIcon : WarningIcon} size="60px" />
    </div>
    {title && <div className="title">{title}</div>}
    <div className="text">{children}</div>
  </Wrapper>
)
